import './collection.scss';
import gameCollection from '../gameCollection.json';

class CollectionControls {

  buildCollectionSection(lang, theme) {
    let collectionSection = document.createElement('section');
    let collectionInformation = document.createElement('div');
    let collectionInformationImg = document.createElement('div');
    let collectionInformationName = document.createElement('div');
    let collectionInformationSong = document.createElement('div');
    let collectionInformationPlayer = document.createElement('div');
    let player = document.createElement('div');
    let playerButton = document.createElement('div');
    let audioProgress = document.createElement('div');
    let audioProgressTime = document.createElement('div');
    let audioProgressTimeline = document.createElement('div');
    let audioProgressTimelineProgress = document.createElement('div');
    let volumeControl = document.createElement('div');
    let volumeControlIcon = document.createElement('div');
    let volumeSlider = document.createElement('div');
    let volumeSliderRange = document.createElement('input');
    let InformationDescription = document.createElement('div');
    let audioElement = document.createElement('audio');

    let mainSection = document.querySelector('.main-section');

    collectionSection.classList.add('collection-section');
    collectionInformation.classList.add('information');
    collectionInformationImg.classList.add('information__img');
    collectionInformationName.classList.add('information__name');
    collectionInformationSong.classList.add('information__song');
    collectionInformationPlayer.classList.add('information__player');
    player.classList.add('player');
    playerButton.classList.add('player__button');
    playerButton.classList.add('player__button_icon_play');
    audioProgress.classList.add('audio-progress');
    audioProgressTime.classList.add('audio-progress__time');
    audioProgressTimeline.classList.add('audio-progress__timeline');
    audioProgressTimelineProgress.classList.add('timeline__progress');
    volumeControl.classList.add('volume-control');
    volumeControlIcon.classList.add('volume-control__icon');
    volumeControlIcon.classList.add('volume-control__icon_low');
    volumeSlider.classList.add('volume-slider');
    volumeSlider.classList.add('volume-slider_vertical');
    volumeSliderRange.classList.add('volume-slider__range');
    volumeSliderRange.classList.add('volume-slider__range_vertical');
    volumeSliderRange.type = ('range');
    InformationDescription.classList.add('information__description');

    if (theme === 'dark') {
      collectionSection.classList.add('collection-section_theme-color_dark');
      collectionInformation.classList.add('information_theme-color_dark');
      player.classList.add('player_theme-color_dark');
      playerButton.classList.add('player__button_theme-color_dark');
      audioProgress.classList.add('audio-progress_theme-color_dark');
      volumeControl.classList.add('volume-control_theme-color_dark');
      volumeControlIcon.classList.add('volume-control__icon_theme-color_dark');
      volumeSlider.classList.add('volume-slider_theme-color_dark');
      volumeSliderRange.classList.add('volume-slider__range_theme-color_dark');
    } else {
      collectionSection.classList.add('collection-section_theme-color_light');
      collectionInformation.classList.add('information_theme-color_light');
      player.classList.add('player_theme-color_light');
      playerButton.classList.add('player__button_theme-color_light');
      audioProgress.classList.add('audio-progress_theme-color_light');
      volumeControl.classList.add('volume-control_theme-color_light');
      volumeControlIcon.classList.add('volume-control__icon_theme-color_light');
      volumeSlider.classList.add('volume-slider_theme-color_light');
      volumeSliderRange.classList.add('volume-slider__range_theme-color_light');
    }

    for (let key in gameCollection) {
      let collectionSectionHeader = document.createElement('h2');
      collectionSectionHeader.classList.add('collection-section__header');
      collectionSectionHeader.textContent = key;
      collectionSection.appendChild(collectionSectionHeader);

      for (let i = 0; i < gameCollection[key].length; i++) {
        if (lang === 'ru') {
          InformationDescription.textContent = gameCollection[key][i].description_ru;
        } else {
          InformationDescription.textContent = gameCollection[key][i].description_en;
        }

        collectionInformationImg.style.backgroundImage = `url("${gameCollection[key][i].image}")`;

        collectionInformationName.textContent = gameCollection[key][i].name;
        collectionInformationSong.textContent = gameCollection[key][i].track_name;;
        audioElement.src = gameCollection[key][i].track_link;
        audioProgressTime.textContent = '00:00/00:00';
        volumeSlider.appendChild(volumeSliderRange);
        volumeControl.appendChild(volumeControlIcon);
        volumeControl.appendChild(volumeSlider);
        audioProgressTimeline.appendChild(audioProgressTimelineProgress);
        audioProgress.appendChild(audioProgressTime);
        audioProgress.appendChild(audioProgressTimeline);
        player.appendChild(playerButton);
        player.appendChild(audioProgress);
        player.appendChild(volumeControl);
        player.appendChild(audioElement);
        collectionInformationPlayer.appendChild(player);
        collectionInformation.appendChild(collectionInformationImg);
        collectionInformation.appendChild(collectionInformationName);
        collectionInformation.appendChild(collectionInformationSong);
        collectionInformation.appendChild(collectionInformationPlayer);
        collectionInformation.appendChild(InformationDescription);

        const copyCard = collectionInformation.cloneNode(true);
        collectionSection.appendChild(copyCard);
      }
    }

    mainSection.appendChild(collectionSection);
  }
}

export { CollectionControls };